import { getQueryParams } from '../../../../src/shared/lib';
import { QUERY_PARAM_OPENED_TASK } from '../../pages';
import { history } from '../../../../src/entities/history';

export const deleteTaskIdQueryParam = () => {
  const searchParams = getQueryParams();
  searchParams.delete(QUERY_PARAM_OPENED_TASK);
  history.replace({ search: searchParams.toString() });
};
